import { QueryClient } from 'react-query';
import {
  decreaseBrightness,
  increaseBrightness,
  setSystemBrightness,
} from '../functions';
import { SetBrightnessCommand } from './types';

interface Params {
  command: SetBrightnessCommand;
  query_client?: QueryClient;
}

export const setBrightnessCommand = async ({
  command,
  query_client,
}: Params) => {
  try {
    if (command.data.action) {
      const {
        data: { action },
      } = command;
      if (action === 'brighter') {
        await increaseBrightness();
      } else if (action === 'darker') {
        await decreaseBrightness();
      }
    } else if (command.data.value) {
      const value = parseFloat(command.data.value);
      setSystemBrightness(value);
    }

    query_client?.invalidateQueries('brightness');
  } catch (ex) {
    console.log(ex);
  }
};
